import { useNavigate } from 'react-router-dom'

import { Button } from '@/shared'
import nullPhoto from '@App/assets/images/nullDoctorImage.png'
import { type IDoctor } from '@App/types/doctorsType'
import { common } from '@App/utils'
import { routes } from '@Config/config'

import style from './DoctorCard.module.scss'

interface IProps extends IDoctor {}

export const DoctorCard = (props: IProps) => {
    const { fname, iname, oname, avatar, post, doctorId } = props
    const navigate = useNavigate()
    // const temporaryId = '6c1ecc21-9eac-4851-b547-7c44c2570cf1'
    const onChoseDoctor = () => navigate(`${routes.DOCS}/${doctorId}`)
    return (
        <div className={style.container}>
            <div className={style.imgWrapper}>
                <img
                    src={avatar || nullPhoto}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null
                        currentTarget.src = 'https://www.meme-arsenal.com/memes/20d600dd79c74b47a39ec029235fa3a1.jpg'
                    }}
                    alt='Изображение не работает'
                />
            </div>
            <div className={style.dataWrapper}>
                <span>{common.fioHandler({ fname, iname, oname }, 'fullname')}</span>
                <span>{post}</span>
            </div>
            <Button onClick={onChoseDoctor}>Редактировать</Button>
        </div>
    )
}
